import type {expedientNotesRouteApi} from "./-route-api";
import {z} from "zod";

// Aggregate-backed Notes have presentation-only URL state, not a backend inclusion flag.
export const expedientNotesSearchSchema = z.object({
  page: z.number().int().min(1).catch(1),
  perPage: z.number().int().min(1).max(100).catch(10),
  q: z.string().optional().catch(undefined),
  sortBy: z.enum(["title", "content", "editedAt"]).catch("title"),
  sortDir: z.enum(["asc", "desc"]).catch("asc"),
});
export type ExpedientNotesSearch = z.output<typeof expedientNotesSearchSchema>;
export type ExpedientNotesNavigateFn = ReturnType<typeof expedientNotesRouteApi.useNavigate>;
